import { gql } from "@apollo/client";

export const StatisticalSearch = gql`
  query StatisticalSearch(
    $city_id: Int!
    $category: Int!
    $first_period: String!
    $second_period: String!
    $time_range_type: TimeRangeType!
  ) {
    Search {
      getCityPriceAverageChanges(
        city_id: $city_id
        category: $category
        first_period: $first_period
        second_period: $second_period
        time_range_type: $time_range_type
      ) {
        district_id
        average_change
      }
    }
  }
`;

export const GET_RESIDENTIAL_STATS_CONFIG = gql`
  query GET_RESIDENTIAL_STATS_CONFIG {
    Info {
      configurations {
        residential_stats {
          for_sale {
            category
            name_ar
            name_en
            svg_icon
            png_icon
            size_unit_ar
            size_unit_en
          }
          for_rent {
            category
            name_ar
            name_en
            svg_icon
            png_icon
            size_unit_ar
            size_unit_en
          }
        }
      }
    }
  }
`;

export const GET_LAST_STAT = gql`
  query GET_LAST_STAT($district_id: Int!, $category: Int!, $size: String) {
    ResidentialIndicators {
      getLastStat(district_id: $district_id, category: $category, size: $size) {
        value
        period_range
        period_type
        message_ar
        message_en
      }
    }
  }
`;

export const GET_STATS = gql`
  query GET_STATS(
    $district_id: Int!
    $category: Int!
    $period_type: ResidentialIndicatorsPeriodTypeEnum!
    $size: String
  ) {
    ResidentialIndicators {
      getStats(
        district_id: $district_id
        category: $category
        period_type: $period_type
        size: $size
      ) {
        stats {
          value
          period_range
          period_type
        }
        message_ar
        message_en
      }
    }
  }
`;
